/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters,
  mapState
} from 'vuex';
import {
  bus
} from '../../main';
import { VueEditor } from "vue2-editor";
export default {
  name: 'edit-assignment',
  components: {
    VueEditor
  },
  props: ['updateAssignmentByID'],
  data() {
    return {
      name: '',
      description: '',
      id: '',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData:''
    }
  },
  computed: {
    ...mapGetters([
      'singleAssignmentState'
    ]),
    getCourseAssignmentByID() {
      this.$store.dispatch('getSignleAssignmentActn', {
        id: this.updateAssignmentByID
      }).then((res) => {
        console.log(this.$store.getters.singleAssignmentState)
        this.name = this.$store.getters.singleAssignmentState.name;
        this.description = this.$store.getters.singleAssignmentState.description;
      }).catch((err) => {})
    }
  },
  mounted() {
    this.getCourseAssignmentByID
  },
  methods: {
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        bus.$emit('HideUpdateAssignmentPopup', false)
      }).catch((err) => {})
    },
    popupCloseFun() {
      bus.$emit('HideUpdateAssignmentPopup', false)
    },
    validateAssignmentBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.name,
            description: this.description,
          }
          this.$store.dispatch('updateAssignmentDetailsByID', {
              data: {
                data: data,
                id: this.updateAssignmentByID
              }
            })
            .then((res) => {
              this.getCourseDetailsAgain();
              toast.success(res.data.msg);
            })
            .catch((err) => {})
          return
        }
      });
    }
  }
}